import filterFileList from "./filterFileList";

/**
 * Remove a file from an `HTMLInputElement.files` property at the given index.
 * @param {HTMLInputElement} fileInput
 * @param {number} fileIndex
 */
const removeFile = ( fileInput, fileIndex ) => {
    if ( fileInput instanceof HTMLInputElement ) {
        const current = fileInput.files.length;
        if ( current > fileIndex ) {
            fileInput.files = filterFileList( fileInput.files, (file, index) => index !== fileIndex );
            return fileInput.files.length !== current;
        }
    }
    return false;
};

export default removeFile;